export const ASSEMBLING_YOUR_ASSEMBLY = 'Assembling your Assembly';
export const CONTACTING_ROBOTS = 'Contacting the robots';
export const DOCUMENTING_DOCUMENTS = 'Documenting documents';
export const ORGANIZING_URLS = 'Organizing URLs';
export const PUTTING_ONLINE = 'Putting things back online';
export const ROBOTS_CONTACTED = 'Robots contacted';
export const TAKING_OFFLINE = 'Taking things offline';
export const ZEEP_ZOOP_ZOP = 'Zeep Zoop Zop';

export const GO_BACK_TO_CHROME_STORE = 'Go back to Chrome Store';
export const POWERED_BY = 'Powered by';
export const RETRY_OR_REDOWNLOAD =
  'We had trouble reaching our database to get you started. Retry, or try re-downloading the extension.';
export const SOMETHING_WENT_WRONG = 'Oops! It looks like something went wrong.';
export const TRY_AGAIN = 'Try again';
